import moment from 'moment-timezone';

export default ({ req }, inject) => {
  const language = getLanguage(req);
  const localMoment = moment().locale(language);
  const LT = localMoment.localeData().longDateFormat('LT');
  const LTS = localMoment.localeData().longDateFormat('LTS');

  moment.updateLocale('fr', {
    monthsShort: ['janv.', 'févr.', 'mars', 'avril', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
    longDateFormat: {
      // Example: "15:30" (time in hours and minutes)
      LT,
      // Example: "15:30:45" (time in hours, minutes, and seconds)
      LTS,
      // Example: "8 avril" (day and month)
      L: 'D MMMM',
      // Example: "8ᵉ avril" (ordinal day and month)
      l: 'Do MMMM',
      // Example: "8 avril 2025" (day, month, and year)
      LL: 'L YYYY',
      // Example: "8ᵉ avril 2025" (ordinal day, month, and year)
      ll: 'l YYYY',
      // Example: "8 avril 2025, 15:30" (day, month, year, and time)
      LLL: 'LL, LT',
      // Example: "8ᵉ avril 2025, 15:30" (ordinal day, month, year, and time)
      lll: 'll, LT',
      // Example: "8 avril 2025, 15:30 UTC+2" (day, month, year, time, and timezone)
      LLLL: 'LLL z',
      // Example: "8ᵉ avril 2025, 15:30 UTC+2" (ordinal day, month, year, time, and timezone)
      llll: 'lll z',
    },
  });

  moment.updateLocale('en', {
    monthsShort: ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
    longDateFormat: {
      // Example: "3:30 PM" (time in hours and minutes)
      LT,
      // Example: "3:30:45 PM" (time in hours, minutes, and seconds)
      LTS,
      // Example: "April 8" (month and day)
      L: 'MMMM D',
      // Example: "April 8ᵗʰ" (month and ordinal day)
      l: 'MMMM Do',
      // Example: "April 8, 2025" (month, day, and year)
      LL: 'MMMM D, YYYY',
      // Example: "April 8ᵗʰ, 2025" (month, ordinal day, and year)
      ll: 'l, YYYY',
      // Example: "April 8, 2025 - 3:30 PM" (month, day, year, and time)
      LLL: 'LL - LT',
      // Example: "April 8ᵗʰ, 2025 - 3:30 PM" (month, ordinal day, year, and time)
      lll: 'll - LT',
      // Example: "April 8, 2025 - 3:30 PM UTC+2" (month, day, year, time, and timezone)
      LLLL: 'LLL z',
      // Example: "April 8ᵗʰ, 2025 - 3:30 PM UTC+2" (month, ordinal day, year, time, and timezone)
      llll: 'lll z',
    },
  });

  inject('moment', moment);
};

function getLanguage(request: any) {
  if (process.client) return navigator.language;

  const acceptLanguage = request?.headers?.['accept-language'];
  if (acceptLanguage) {
    const firstAcceptLanguage = acceptLanguage.replace(/\s/g, '').split(/[;,]/)[0];
    return firstAcceptLanguage === '*' ? 'en' : firstAcceptLanguage;
  }

  return 'en';
}
